import { render } from "./MenuTrigger.vue?vue&type=template&id=941a8402&ts=true"
import script from "./MenuTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuTrigger.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuTrigger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "941a8402"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('941a8402', __exports__)) {
    api.reload('941a8402', __exports__)
  }
  
  module.hot.accept("./MenuTrigger.vue?vue&type=template&id=941a8402&ts=true", () => {
    api.rerender('941a8402', render)
  })

}


export default __exports__